/**
 * Copy given text to user's clipboard.
 */
export const copyToClipboard = (text: string) => navigator.clipboard.writeText(text);
